// --
import React from 'react';
import {connect} from "react-redux";
import AbstractReactComponent from "../AbstractReactComponent";
import Icon from "../icon/FAIcon";
import * as games from "../games/index";
import * as modal from "../modal/index";
import {Collapse, Nav, Navbar, NavbarBrand, NavbarToggler, NavDropdown} from "reactstrap";
import {LinkContainer} from "react-router-bootstrap";
import NavIconText from "../navbar/NavIconText";

import "./AppNavbarWrapper.scss";
import MCIcon from "../icon/MCIcon";
import {withRouter} from "react-router";

var _gameRunner = null;

class AppNavbarWrapper extends AbstractReactComponent {
    static propTypes = {
        appCode: React.PropTypes.string,
        appName: React.PropTypes.oneOfType([    // název aplikace, který se zobrazuje jako brand, mu6e se jednat i o název globální logické sekce, např. skprávní řízení apod.
            React.PropTypes.array,
            React.PropTypes.node
        ]),
        fluid: React.PropTypes.bool,    // pokud je true, jedná se o kontejner fluid - na celou stránku, implicitně je false
        detail: React.PropTypes.oneOfType([ // detail informace aplikace, např. text detailu stránky, globální filtr stránky atp.
            React.PropTypes.array,
            React.PropTypes.node
        ]),
        homeLink: React.PropTypes.oneOfType([
            React.PropTypes.func,   // pokud je uvedeno, volá se tento callback při klinutí
            React.PropTypes.string, // přesouvá se na uvedenou url - url pro router, pro renderování je použita komponenta homeLinkComponent, implicitně LinkContainer
        ]),
        homeLinkComponent: React.PropTypes.oneOfType([  // komponenta pro renderování home linku (ne back), implicitně LinkContainer
            React.PropTypes.func,
            React.PropTypes.string
        ]),
        onHistoryGoBack: React.PropTypes.func.isRequired,   // funkce pro zpracování posunu back, předpis: (goBackBase, homeLink) => {}
        backButtonIcon: React.PropTypes.bool,   // má se místo loga aplikace zobrazit back button?
        // collapseAddons
        // centerAddons
        goBack: React.PropTypes.bool,   // pokud je true, je kliknutí na brand bráno jako back
        goBackBase: React.PropTypes.string, // základní url, která reprezentuje základ aktuálně zobrazované stránky - při stisku back se půjde na první, která namá prefix uvedený v goBackBase
        testEnvironment: React.PropTypes.bool,     // pokud je true, jedná se o testovací prostředí
    };

    static defaultProps = {
        homeLinkComponent: LinkContainer,
        fluid: false,
        backButtonIcon: false,
        goBack: false,
        testEnvironment: false,
    };

    state = {
        collapseIsOpen: false,
        canStartGame: false,
    };

    componentWillUnmount() {
        if (_gameRunner) {
            clearTimeout(_gameRunner);
        }
    }

    // componentDidMount() {
    //     this.handleShowGame(2)
    // }

    handleGameStartLeave = () => {
        if (_gameRunner) {
            clearTimeout(_gameRunner);
            _gameRunner = null;
        }
        this.setState({canStartGame: false});
    };

    handleGameStartOver = () => {
        if (_gameRunner) {
            clearTimeout(_gameRunner);
            _gameRunner = null;
        }
        _gameRunner = setTimeout(() => {
            this.setState({canStartGame: true});
        }, 1000);
    };

    historyGoBack = (e) => {
        const {onHistoryGoBack, goBackBase, homeLink} = this.props;

        e.stopPropagation();
        e.preventDefault();

        onHistoryGoBack(goBackBase, homeLink);
    };

    handleShowGame = (game) => {
        if (confirm("Opravdu si chcete zahrát hru? Hraní této hry je pouze na vašem rozhodnutí a společnost Marbes Consulting s.r.o. za toto nenese žádnou odpovědnost.")) {
            switch (game) {
                case 1:
                    this.props.dispatch(modal.ModalActions.show(
                        games.Tetris, null, "Tetris", {size: "md"}
                    ));
                    break;
                case 2:
                    this.props.dispatch(modal.ModalActions.show(
                        games.Sokoban, null, "Sokoban", {size: "md"}
                    ));
                    break;
                case 3:
                    this.props.dispatch(modal.ModalActions.show(
                        games.Mines, null, "Hledání min", {size: "md"}
                    ));
                    break;
                case 4:
                    this.props.dispatch(modal.ModalActions.show(
                        games.Pexeso, null, "Pexeso", {size: "xl"}
                    ));
                    break;
            }
        }
    };

    render() {
        const {homeLinkComponent, fluid, appCode, centerAddons, collapseAddons, areas, areasTitle, detail, homeLink, goBack, backButtonIcon, appName, testEnvironment} = this.props;
        const {canStartGame} = this.state;

        // Brand logo - ikona, název a případně popis
        let brandLogo;
        let icon;
        if (backButtonIcon) {
            icon = <Icon fixedWidth className="header-app-icon" icon="chevron-left"/>;
        } else {
            icon = <MCIcon fixedWidth className="header-app-icon" icon={appCode} />;
        }

        let classLogo = "header-logo";
        if (testEnvironment) {
            classLogo += " test";
        }

        brandLogo = <div key="logo" className={classLogo}>
            {icon}
            <div className="header-app-name-container">
                <span className="header-app-name">{appName}{buildNumber && <small> {buildNumber}</small>}</span>
            </div>
        </div>;

        // Celý brand včetně klikání
        let brand;
        if (goBack && this.props.history.length > 0) {   // máme aplikační historii a chceme jít zpět - jako v prohlížeči
            brand = <NavbarBrand key="brand" href="" className="app-header-left" key="header" onClick={this.historyGoBack}>{brandLogo}</NavbarBrand>
        } else {
            if (typeof homeLink === "function") {
                brand = <NavbarBrand key="brand" className="app-header-left" href="#" onClick={homeLink} key="header">{brandLogo}</NavbarBrand>
            } else if (homeLink) {
                brand = React.createElement(homeLinkComponent, { to: homeLink, key: "brand" }, <NavbarBrand className="app-header-left" key="header">{brandLogo}</NavbarBrand>);
            } else {
                brand = <NavbarBrand key="brand" className="app-header-left" key="header">{brandLogo}</NavbarBrand>;
            }
        }

        // Oblasti
        let appMainAreas;
        if (areas) {
            appMainAreas = <NavDropdown key="main-areas" noCaret id="user" className="app-main-areas"
                                        title={<span><Icon icon='bars'/></span>}>
                {areas}
            </NavDropdown>;
        }
        let appRightAreas;
        if (areas) {
            appRightAreas = <NavDropdown key="main-areas-right" className=""
                                         title={<span className="hidden-md hidden-lg hidden-xl"><NavIconText icon={<Icon icon='bars'/>} text={areasTitle}/></span>}>
                {areas}
            </NavDropdown>;
        }

        return (
            <Navbar key="navbar" className={"app-header navbar-light"} toggleable="sm">
                <div key="container" className={fluid ? "app-container-fluid" : "app-container"}>
                    <div key="game1" onClick={() => {
                        canStartGame && this.handleShowGame(1)
                    }} onMouseEnter={this.handleGameStartOver} onMouseLeave={this.handleGameStartLeave} className={"game-placeholder " + (canStartGame ? "canStart" : "")}>
                        &nbsp;
                    </div>
                    <div key="game2" onClick={() => {
                        canStartGame && this.handleShowGame(2)
                    }} onMouseEnter={this.handleGameStartOver} onMouseLeave={this.handleGameStartLeave} className={"game-placeholder2 " + (canStartGame ? "canStart" : "")}>
                        &nbsp;
                    </div>
                    <div key="game3" onClick={() => {
                        canStartGame && this.handleShowGame(3)
                    }} onMouseEnter={this.handleGameStartOver} onMouseLeave={this.handleGameStartLeave} className={"game-placeholder3 " + (canStartGame ? "canStart" : "")}>
                        &nbsp;
                    </div>
                    <div key="game4" onClick={() => {
                        canStartGame && this.handleShowGame(4)
                    }} onMouseEnter={this.handleGameStartOver} onMouseLeave={this.handleGameStartLeave} className={"game-placeholder4 " + (canStartGame ? "canStart" : "")}>
                        &nbsp;
                    </div>

                    {brand}
                    <NavbarToggler key="toggler" right className="mt-1" onClick={() => this.setState({collapseIsOpen: !this.state.collapseIsOpen})}/>
                    <Nav key="main-areas" className="app-menu pull-right hidden-xs">
                        {appMainAreas}
                    </Nav>
                    <span key="header-detail" className="app-header-detail">
                        {detail}
                    </span>
                    <Collapse key="right-menu" navbar isOpen={this.state.collapseIsOpen}>
                        {centerAddons}
                        <div key="others" className="ml-auto">
                            <Nav key="nav" className="app-menu" navbar>
                                {collapseAddons}
                            </Nav>
                            {appRightAreas}
                        </div>
                    </Collapse>
                </div>
            </Navbar>
        )
    }
}

export default withRouter(connect()(AppNavbarWrapper));
